import { handleActions } from 'redux-actions';
import { RootState, UIState } from 'types';
import uiActions from './actions';

export default handleActions<UIState, any>(
  {
    [uiActions.toggleSidebar.toString()]: (state, action) => ({
      ...state,
      showSidebar:
        action.payload !== undefined ? action.payload : !state.showSidebar
    }),
    [uiActions.setRef.toString()]: (state, action) => ({
      ...state,
      ref: action.payload
    }),
    [uiActions.clearRef.toString()]: state => ({ ...state, ref: '' })
  },
  {
    showSidebar: true,
    ref: ''
  }
);

export const getShowSidebar = (state: RootState) => state.ui.showSidebar;

export const getRef = (state: RootState) => state.ui.ref;
